import webClient from "../config/api.config";
import { FeatureFlagPayload } from "../types/featureFlag.definition";

export function requestGetFeatureFlags() {
  return webClient.request({
    method: "get",
    url: `/feature-flags`,
  });
}

export function requestCreateFeatureFlag(data: FeatureFlagPayload) {
  return webClient.request({
    method: "post",
    url: `/feature-flags`,
    data,
  });
}

export function requestUpdateFeatureFlag(id: number, data: FeatureFlagPayload) {
  return webClient.request({
    method: "put",
    url: `/feature-flags/${id}`,
    data,
  });
}

export function requestDeleteFeatureFlag(id: number) {
  return webClient.request({
    method: "delete",
    url: `/feature-flags/${id}`,
  });
}
